import axios from 'axios'
import baseStore from '../../index'

const state = {
  bookingItems: (localStorage.getItem("bookingItems")) ? JSON.parse(localStorage.getItem('bookingItems')) : [],
  selectedHours: [],
  requestDetails: []
}

const mutations = {
  UPDATE_BOOKING_LIST(state, payload) {
    state.bookingItems = payload
  },
  UPDATE_BOOKING_HOURS(state, payload) {
    if (state.selectedHours.length > 0) {
      state.selectedHours[0].items.push(payload.items[0]);
      state.selectedHours[0].items = state.selectedHours[0].items.sort((a,b) => a.index - b.index);
    } else {
      state.selectedHours.push(payload)
    }
    //console.log(state.selectedHours)
  },
  UPDATE_REQUEST_DETAILS (state, payload) {
    state.requestDetails = payload;
  },
  REMOVE_BOOKING_HOURS(state, payload) {
    let hourItem = state.selectedHours[0].items.find(
      (hourItem) => hourItem.startHour === payload.items[0].startHour
    )
    state.selectedHours[0].items = state.selectedHours[0].items.filter(
      (item) => item !== hourItem
    )
    if (state.selectedHours[0].items.length == 0) state.selectedHours = []
  },
  REMOVE_REQUESTS(state) {
    state.selectedHours = []
  },
}

const actions = {
  async getbookingItems ({ commit }, token) {
    console.log('getBookingItems => offline: '+ baseStore.getters.offlineMode)
    if (baseStore.getters.offlineMode) {
      const bookings = JSON.parse(localStorage.getItem('bookingItems'))
      commit('UPDATE_BOOKING_LIST', bookings)
    } else {
      await axios
      .get(baseStore.getters.apiPath +'bookings', {
          headers: {
            'Authorization': `JWT ${token}`
          }
        }
      )
      .then((response) => {
        if (response.data.error) {
          global.showError(response.data.error, response.data.login)
        } else {
          localStorage.setItem('bookingItems', JSON.stringify(response.data))
          commit('UPDATE_BOOKING_LIST', response.data)
        }
        //console.log(state.bookingItems);
      })
      .catch((error) => {
        global.showError(error)
        console.log("GET call unsuccessful :(", error);
      });
    }
  },
  setRequestDetail({ commit }) {
    if (state.selectedHours.length == 0) return ''
    let index = state.selectedHours[0].items[0].index
    let indexDetail = 0
    let arrDetails = []
    arrDetails.push({ 'start': state.selectedHours[0].items[0].startHour, 'end': state.selectedHours[0].items[0].endHour })
    for (let i = 1; i < state.selectedHours[0].items.length; i++) {
      if (index === state.selectedHours[0].items[i].index - 1) {
        arrDetails[indexDetail].end = state.selectedHours[0].items[i].endHour
      } else {
        arrDetails.push({ 'start': state.selectedHours[0].items[i].startHour, 'end': state.selectedHours[0].items[i].endHour })
        indexDetail++
      }
      index = state.selectedHours[0].items[i].index
    }
    //console.log(arrDetails)
    commit('UPDATE_REQUEST_DETAILS', arrDetails);
  },
  selectHour({ commit }, newHour) {
    //console.log(newHour);
    commit('UPDATE_BOOKING_HOURS', newHour)
  },
  removeHour({ commit }, newHour) {
    commit('REMOVE_BOOKING_HOURS', newHour)
    //console.log(state.selectedHours);
  },
  removeAllRequests({ commit }) {
    commit('REMOVE_REQUESTS')
    //console.log(state.selectedHours);
  },
  removeBooking({ commit }, bookingItem) {
    if (baseStore.getters.isOffline) {
      return 'Action unavailable while offline'
    } else {
    //console.log(bookingItem);
    const token = localStorage.getItem("token");
    axios
      .post(baseStore.getters.apiPath +'bookings/delete', 
        bookingItem, {
          headers: {
            'Authorization': `JWT ${token}` 
          }
        }
      )
      .then((response) => {
        if (response.data.error) {
          global.showError(response.data.error, response.data.login)
        } else {
          localStorage.setItem('bookingItems', JSON.stringify(response.data))
          commit('UPDATE_BOOKING_LIST', response.data);
        }
      })
      .catch((error) => {
        global.showError(error)
        console.log("POST call unsuccessful :(", error);
    });
  }
  },
  async sendRequest({ commit }, newRequest) {
    //console.log(newRequest);
    const token = localStorage.getItem("token");
    return axios
      .post(baseStore.getters.apiPath +'bookings', 
        newRequest, {
          headers: {
            'Authorization': `JWT ${token}` 
          }
        }
      )
      .then((response) => {
        if (response.data.error) {
          global.showError(response.data.error, response.data.login)
          return { requestSent: false, error: response.data.error }
        } else {
          const returnJson = JSON.stringify(response.data.bookings)
          localStorage.setItem('bookingItems', returnJson)
          commit('UPDATE_BOOKING_LIST', response.data.bookings);
          if (response.data.errors) {
            return { requestSent: true, error: response.data.errors }
          } else {
            return { requestSent: true }
          }
        }
      })
      .catch((error) => {
        global.showError(error)
        console.log("POST call unsuccessful :(", error);
        return false
    });
  }
}

const getters = {
  bookingItems: (state) => state.bookingItems,
  roomItemFromId: (state) => (dayId, roomId) => {
    //console.log("roomItemFromId - dayId: "+ dayId +" roomId: "+ roomId);
    let roomItems = state.bookingItems.find(
      (dayItem) => dayItem.id === Number(dayId)
    )
    if (!roomItems) return null
    let roomItem = roomItems.items.find(
      (roomItem) => roomItem.id === Number(roomId)
    )
    //console.log(roomItem)
    return roomItem
  },
  roomItemsFromDay: (state) => (dayId) => {
    //console.log("roomItemsFromDay - dayId: "+ dayId);
    let roomItems = state.bookingItems.find(
      (roomItem) => roomItem.id === Number(dayId)
    )
    return roomItems
  },
  getSelectedHours: state => state.selectedHours,
  countSelectedHours: state => {
    if (state.selectedHours.length == 0) return 0
    let max = 1
    let index = state.selectedHours[0].items[0].index
    for (let i = 1; i < state.selectedHours[0].items.length; i++) {
      if (index === state.selectedHours[0].items[i].index - 1) {
        max++
        if (max == 3) return max
      } else {
        max = 1
      }
      index = state.selectedHours[0].items[i].index
    }
    return max
  },
  getRequestDetails: state => state.requestDetails
}

const bookingsModule = {
  state,
  mutations,
  actions,
  getters,
}

export default bookingsModule
